import { animaliaListingDesignTokens } from '../../shared/animalia-listing-design-tokens';

export class MvAnimaliaListingCardExcerpt extends HTMLElement {
  private heading = '';

  private body = '';

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setContent(title: string, body: string): void {
    this.heading = title;
    this.body = body;
    this.render();
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaListingDesignTokens}

        .excerpt-box {
          margin-top: 18px;
          padding: 16px;
          border-radius: 18px;
          background: linear-gradient(180deg, rgba(223, 213, 197, 0.45), rgba(223, 213, 197, 0.2));
          border: 1px solid rgba(155, 123, 99, 0.12);
        }

        strong {
          display: block;
          margin-top: 8px;
          color: #31463d;
          line-height: 1.45;
        }

        p {
          margin: 10px 0 0;
          line-height: 1.7;
          color: rgba(32, 39, 32, 0.64);
        }
      </style>

      <div class="excerpt-box">
        <strong>${this.escapeHtml(this.heading)}</strong>
        <p>${this.escapeHtml(this.body)}</p>
      </div>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

if (!customElements.get('mv-animalia-listing-card-excerpt')) {
  customElements.define('mv-animalia-listing-card-excerpt', MvAnimaliaListingCardExcerpt);
}
